export default {
  updateUserId(state, payload) {
    state.userid = payload;
  },

  updateRightPage(state, payload) {
    state.rightPage = payload;
  },

  updateProfile(state, payload) {
    state.profile = payload;
    if (!payload) {
      state.isTeacher = false;
      state.isStudent = false;
      return;
    }

    let roles = payload.roles || [];
    state.isTeacher = roles.indexOf('59648962ca544543e1ba90e1') >= 0;
    state.isStudent = roles.indexOf('59648973ca544543e1ba90e2') >= 0;
  },

  updateRoles(state, payload) {
    state.roles = payload;
  },

  updateSubjects(state, payload) {
    state.subjects = payload;
  },

  updateSchoolSystems(state, payload) {
    state.schoolSystems = payload;
  },

  updateAppLoading(state, payload) {
    state.appLoading = payload;
  }
};
